import { SOURCE } from 'constants/general';
import { createDecagonClient } from '@user-portal/chatbot';

export const decagonClient = createDecagonClient({
    projectId: 'yoga',
    source: SOURCE,
    env: import.meta.env.ENV === 'prod' ? 'prod' : 'stage',
});
